import React, {
    useState,
    useEffect,
    forwardRef,
    useImperativeHandle,
} from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { dataUser, spocLocationDetailsZoho } from '../Helpers/util';
import SwSelect from '../Common/SwReactSelect/SwReactSelect';
import SwInput from '../Common/FormComponent/SwInput';
import AntDDatePicker from '../Common/AntDDateTimePicker/AntDDatePicker';
import dayjs from 'dayjs';


const SkyWatchServiceRequest = forwardRef(({ onClose }, ref) => {
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [locationData, setLocationData] = useState([]);
    const [category, setCategory] = useState('');
    const [date, setDate] = useState('');
    const [date1, setDate1] = useState('');
    const [locationError, setLocationError] = useState('');
    const [categoryError, setCategoryError] = useState('');
    const [dateError, setDateError] = useState('');
    const [date1Error, setDate1Error] = useState('');
    const [loading, setLoading] = useState(false);
    const userDataLocal = dataUser();
    const UserObj = JSON.parse(userDataLocal);
    const userDataLocal12 = spocLocationDetailsZoho();

    useEffect(() => {
        const LocationSpoc = JSON.parse(userDataLocal12);
        setLocationData(LocationSpoc);
    }, []);

    // expose methods to parent (SwOffCanvas)
    useImperativeHandle(ref, () => ({
        resetForm() {
            resetValue();
        },
        submitRequest() {
            handleSubmit();
        },
        loading,
    }));


    const changeSelect = (option) => {
        setSelectedLocation(option);
        setLocationError('');
    };

    const handleSubmit = async () => {
        if (!selectedLocation) {
            setLocationError("Location can't be empty");
            return;
        }
        if (!category) {
            setCategoryError("Number of devices can't be empty");
            return;
        }
        if (!date) {
            setDateError("Start date can't be empty");
            return;
        }
        if (!date1) {
            setDate1Error("End date can't be empty");
            return;
        }

        setLoading(true);
        const authToken = JSON.parse(localStorage.getItem('headData'));

        const param = {
            product_name: 'SkyWatch',
            start_date: date,
            end_date: date1,
            category,
            company_name: UserObj.company_name,
            email: UserObj.email,
            fname: UserObj.fname,
            lname: UserObj.lname,
            phone: UserObj.phone,
            location_name: selectedLocation.label,
            location_id: selectedLocation.value,
        };

        try {
            const res = await axios.post(
                `${process.env.REACT_APP_API_URL}basic-data/new-product-enquiry`,
                param,
                {
                    headers: {
                        Authorization: authToken?.spintlyToken,
                    },
                },
            );

            if (res.status === 200) {
                toast.success(res.data.message);
                onClose(true);
            }
        } catch (err) {
            toast.error('Unable to submit SkyWatch request');
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const resetValue = () => {
        setSelectedLocation(null);
        setCategory('');
        setDate('');
        setDate1('');
        setLocationError('');
        setCategoryError('');
        setDateError('');
        setDate1Error('');
    };

    return (
        <><div className="SwFormGroup">
            <label className="SwFormLabel">
                Location <span className="Required">*</span>
            </label>
            <SwSelect
                name="location"
                value={selectedLocation}
                onChange={changeSelect}
                options={locationData}
                isClearable={false}
                className="ParkRequestLocationSelect" />
            <span className="SwTextDanger SwTextSmall"> {locationError}</span>
        </div>
            <div className="SwFormGroup">
                <label className="SwFormLabel">
                    Number of Devices <span className="Required">*</span>
                </label>
                <SwInput
                    type="number"
                    min="0"
                    value={category}
                    onChange={e => {
                        setCategory(e.target.value);
                        setCategoryError('');
                    }} />
                <span className="SwTextDanger SwTextSmall">{categoryError}</span>
            </div>

            <div className="row">
                <div className="col-md-6 pr-2">
                    <div className="SwFormGroup">
                        <label className="SwFormLabel">
                            Start Date <span className="Required">*</span>
                        </label>
                        <AntDDatePicker
                            type="single"
                            value={date ? dayjs(date) : null}
                            onChange={(value) => {
                                setDate(value ? value.format('YYYY-MM-DD') : '');
                                setDateError('');
                            }}
                            format="DD/MM/YYYY"
                            placeholder="Start Date"
                            disabledDate={(current) =>
                                current && current < dayjs().startOf('day')
                            }
                        />
                        <span className="SwTextDanger SwTextSmall">{dateError}</span>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="SwFormGroup">
                        <label className="SwFormLabel">
                            End Date <span className='Required'>*</span>
                        </label>
                        <AntDDatePicker
                            type="single"
                            value={date1 ? dayjs(date1) : null}
                            onChange={(value) => {
                                setDate1(value ? value.format('YYYY-MM-DD') : '');
                                setDate1Error('');
                            }}
                            format="DD/MM/YYYY"
                            placeholder="End Date"
                            disabledDate={(current) =>
                                current &&
                                (current < dayjs(date || undefined).startOf('day'))
                            }
                        />
                        <span className="SwTextDanger SwTextSmall"> {date1Error}</span>
                    </div>
                </div>
            </div>
        </>
    );
});

export default SkyWatchServiceRequest;
